import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  operation: string = 'login';
  email:string = null;
  password:string =null;
  nick:string=null;
  constructor(
      private autheticationService : AuthenticationService,
      private userService: UserService,
      private router: Router
      ) { }

  ngOnInit() {
  }
  login(){
    this.autheticationService.loginWithEmail(this.email,this.password).then(
      (data)=>{
        this.router.navigate(['home']);
        alert("logeado correctamente");
        console.log(data);
      }
    ).catch((error) =>{
      alert("logeado error");
      console.log(error);
    });
  }
  register(){
    this.autheticationService.registerWithEmail(this.email,this.password).then(
      (data)=>{
        const user = {
          uid: data.user.uid,
          email: this.email,
          nick: this.nick
        }
        this.userService.createUser(user).then((registro)=>{
          alert("registrado correctamente");
          console.log(registro);
        }).catch((errorRegistro)=>{
          console.log(errorRegistro);
        });
      }
    ).catch((error) =>{
      alert("registrer error");
      console.log(error);
    });
  }
}
